import React from 'react';
import PropTypes from 'prop-types';
import {TextField} from '@material-ui/core';
import {Translate} from 'react-redux-i18n';

import {useDebounce} from 'front-onceforall-core/dist/utils/customHooks';

function getNewSearchValue(currentValue, newValue, maxQueryLength, shouldTruncate = false) {
  let str = newValue || '';
  if (maxQueryLength && str.length > maxQueryLength) {
    str = str.slice(0, maxQueryLength);
    if (shouldTruncate || str !== currentValue) {
      return str;
    }
    return currentValue;
  }
  return str;
}

function ListSearchBarView(props) {
  const [searchValue, setSearchValue] = React.useState(getNewSearchValue('', props.defaultValue, props.maxQueryLength, true));
  const [typing, setTyping] = React.useState(false);

  const debouncedSearchValue = useDebounce(searchValue);

  function updateSearchValue(value) {
    const newValue = getNewSearchValue(searchValue, value, props.maxQueryLength);
    if (newValue !== searchValue) {
      setSearchValue(newValue);
    }
  }

  function handleChange(event) {
    updateSearchValue(event?.target?.value);
  }

  React.useEffect(() => {
    setTyping(false);
    props.onSearch(debouncedSearchValue);
  }, [debouncedSearchValue]);

  React.useEffect(() => {
    if (!typing && searchValue !== debouncedSearchValue) {
      setTyping(true);
    }
  }, [searchValue]);

  React.useEffect(() => {
    props.isTyping(typing);
  }, [typing]);

  return (
    <>
      <TextField
        label={props.label}
        placeholder={props.placeholder}
        data-id="searchBar"
        value={searchValue}
        onChange={handleChange}
      />
      {props.maxQueryLength && <div>
        <Translate
          value="message.textCounter"
          counter={searchValue.length}
          maxLength={props.maxQueryLength}
        />
      </div>}
    </>
  );
}

ListSearchBarView.defaultProps = {
  placeholder: ''
};

ListSearchBarView.propTypes = {
  onSearch: PropTypes.func.isRequired,
  isTyping: PropTypes.func.isRequired,
  defaultValue: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  placeholder: PropTypes.string,
  maxQueryLength: PropTypes.number
};

export default ListSearchBarView;
